import Splide from '@splidejs/splide'

export function slider() {
	const sliders = []
	var elms = document.getElementsByClassName('splide')

	for (var i = 0; i < elms.length; i++) {
		sliders.push(new Splide(elms[i]).mount())
	}

	const interactiveSlider = document.getElementsByClassName('interactive-splide');
	if(interactiveSlider.length > 0) {
		window.interactiveSlider = new Splide(interactiveSlider[0], {
			'arrows': false,
			'pagination': false,
			'speed': 0
		}).mount()

		const controlButtons = document.getElementsByClassName('quarter-acc__button');
		Array.from(controlButtons).forEach(button => {
			button.addEventListener('click', function () {
				Array.from(controlButtons).forEach(btn => btn.classList.remove('active'));
				this.classList.add('active');
				window.interactiveSlider.go(Number(this.dataset.slideId));
			});
		});
	}

	return sliders
}
